import { IState } from './types';

/**
 * redux state selectors
 */
const getAppState = (state: IState) => state.app;

export const isLoaded = (state: IState) => getAppState(state).loaded;

export const getLoginFormState = (state: IState) => getAppState(state).form;

export const getErrorState = (state: IState) => getAppState(state).error;

export const hasRootError = (state: IState) => !!getErrorState(state).all;

export const isSubmitProgress = (state: IState) => getAppState(state).submit;
